import Cookies from "js-cookie";

const TokenKey = 'admin-Token'

// sessionStorage方法的二次封装（主要是来处理tabview，因产品的需求，tabview不能用localstorage来存储，所以只能把tabview单独存储在storage里面）
export function getSession(key) {
    if (window.sessionStorage) {
        const val = sessionStorage[key]
        if (val) {
            try {
                return JSON.parse(val)
            } catch (ex) { }
        }
    }
    return null
}
export function setSession(key, val) {
    if (window.sessionStorage) {
        sessionStorage[key] = JSON.stringify(val)
    }
}

// 拿到token
export function getToken() {
    return sessionStorage.getItem(TokenKey)
}
// 设置token
export function setToken(token) {
    return sessionStorage.setItem(TokenKey, token)
}
// 删除token
export function removeToken() {
    return sessionStorage.removeItem(TokenKey)
}

// localStorage方法的二次封装
export function getItem(key) {
    if (window.localStorage) {
        const val = localStorage[key]
        if (val) {
            try {
                return JSON.parse(val)
            } catch (ex) { }
        }
    }
    return null
}
export function setItem(key, val) {
    if (window.localStorage) {
        localStorage[key] = JSON.stringify(val)
    }
}
export function delItem(key) {
    if (window.localStorage) {
        localStorage.removeItem(key)
    }
}
